import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isNumber } from "util";
import {
  changeOrdersList,
  sortOrdersList,
  changeOrdersSortBy,
  changeOrdersSortOrder
} from "../../store/order";
import shop from "../../api/shop";
import { store } from "../../main.js";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import {
  getFilter,
  toggleModal,
  getModalStatus,
  getSortByStatus,
  getSortOrderStatus
} from "../../store/common";
import moment from "moment";
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import RangePicker from "./RangePicker";
import { RingLoader } from "react-spinners";

const OrdersFilter = ({
  from,
  to,
  changeOrdersList,
  getIdOrderFilter,
  getPriceOrderFilter,
  getStatusOrderFilter,
  toggleModal,
  getFilterSortDropdownStatus,
  getSortBy,
  changeOrdersSortBy,
  getSortOrder,
  changeOrdersSortOrder,
  sortOrdersList,
  getCustomers,
  isCustomersLoading
}) => {
  const modifiers = { start: from, end: to };
  return (
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div className="filterSetup">
          <h5 className="filterSetup__heading">Search in orders</h5>

          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="id">ID</label>
                <input
                  type="text"
                  id="id"
                  value={getIdOrderFilter}
                  onChange={e => {
                    changeOrdersList(e.target.value, "id");
                    //e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder="ID"
                  aria-label="ID"
                  aria-describedby="basic-addon2"
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="price">Price</label>
                <input
                  type="text"
                  id="price"
                  value={getPriceOrderFilter}
                  onChange={e => {
                    changeOrdersList(e.target.value, "price");
                    //e.stopPropagation();
                  }}
                  className="form-control"
                  placeholder="Price"
                  aria-label="Price"
                  aria-describedby="basic-addon2"
                />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="status">Status</label>
                <select
                  type="text"
                  //   value={getStatusOrderFilter}
                  id="status"
                  onChange={e => {
                    changeOrdersList(e.target.value, "state");
                    //e.stopPropagation();
                  }}
                >
                  <option value="-1">-choose-</option>
                  <option value="new">new</option>
                  <option value="paid">paid</option>
                  <option value="shipped">shipped</option>
                </select>
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="status">Customer</label>
                {isCustomersLoading ? (
                  <RingLoader color={"#d42e2b"} loading={isCustomersLoading} />
                ) : (
                  <select
                    type="text"
                    id="customer"
                    onChange={e => {
                      changeOrdersList(e.target.value, "customer");
                      //e.stopPropagation();
                    }}
                  >
                    <option value="-1">-choose-</option>
                    {getCustomers &&
                      getCustomers.map(c => (
                        <option key={c.personal.id} value={c.personal.id}>
                          {c.personal.code} - {c.company.company}
                        </option>
                      ))}
                  </select>
                )}
              </div>
            </div>
            <div className="col-xs-6 col-sm-12 col-md-6">
              <div className="filterSetup__inputGroup">
                <label htmlFor="Range">Range</label>
                <RangePicker />
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-3">
              <div className="filterSetup__inputGroup">
                <label htmlFor="sortBy">Sort by</label>

                <div className="orderGroup">
                  <div className="orderGroup__half">
                    <select
                      name="sortBy"
                      id="sortBy"
                      onChange={e => {
                        changeOrdersSortBy(e.target.value);
                        sortOrdersList(e.target.value, getSortOrder);
                      }}
                    >
                      <option value="id">Id</option>
                      <option value="price">Price</option>
                      <option value="date">Date</option>
                      <option value="state">State</option>
                    </select>
                  </div>
                  <div className="orderGroup__half">
                    <button
                      type="button"
                      className={
                        "button-filter asc  " +
                        (getSortOrder === "asc" ? "active" : null)
                      }
                      onClick={() => {
                        changeOrdersSortOrder("asc");
                        sortOrdersList(getSortBy, "asc");
                      }}
                    >
                      {/* <i className="fa fa-sort-amount-asc"></i> */}
                    </button>
                    <button
                      type="button"
                      className={
                        "button-filter desc  " +
                        (getSortOrder === "desc" ? "active" : null)
                      }
                      onClick={() => {
                        changeOrdersSortOrder("desc");
                        sortOrdersList(getSortBy, "desc");
                      }}
                    >
                      {/* <i className="fa fa-sort-amount-desc"></i> */}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
OrdersFilter.propTypes = {};

const mapStateToProps = state => ({
  getIdOrderFilter: getFilter(state.order.filter, "id"),
  getPriceOrderFilter: getFilter(state.order.filter, "price"),
  getStatusOrderFilter: getFilter(state.order.filter, "state"),
  getFilterSortDropdownStatus: getModalStatus(
    state.common.modals ? state.common.modals.filter_order_sort : null
  ),
  getSortBy: getSortByStatus(state.order.sortBy),
  getSortOrder: getSortOrderStatus(state.order.sortOrder),
  from: "April 19, 2018",
  to: "April 27, 2018",
  getCustomers: state.customer.list || [],
  isCustomersLoading: state.customer.loading
});

const mapDispatchToProps = dispatch => ({
  changeOrdersList: (val, type) => {
    dispatch(changeOrdersList(val, type));
  },
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, !action)),
  changeOrdersSortBy: sortBy => dispatch(changeOrdersSortBy(sortBy)),
  changeOrdersSortOrder: sortOrder =>
    dispatch(changeOrdersSortOrder(sortOrder)),
  sortOrdersList: (sortBy, sortOrder) =>
    dispatch(sortOrdersList(sortBy, sortOrder))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrdersFilter);



// WEBPACK FOOTER //
// ./src/molecules/containers/OrdersFilter.js